<div class="div-wrap">
  <div class="header">
      <div class="logo">
          <h1><a href="#">404</a></h1>
      </div>
  </div>
 
  <div class="content">
      <img src="assets/images/error-img.png" title="Page Not Found......"  />
      <p><span><label></label>Sorry.....</span>You Requested the page that is no longer There.</p>

      <a (click)="HomePage()">Back To Home</a>
      
      <div class="copy-right">
          <p>&copy; 2018 Ernst & Young All Rights Reserved</p>
      </div>
  </div>
</div>
